const TOAST = 'pro-studio/navigation:publish_modal.toast';

type Copy = { key: string; defaultValue: string };

/**
 * The publish toasts' keys (PSTUDIO-4635). With Bobcat's master flag off they
 * are production's, word for word (Definition of done #2); the shorter Bobcat
 * wording shows only with it on. Shared by the publish modal and the coworker
 * watcher, which raise the same toasts.
 */
export const publishToastCopy = (
  bobcat: boolean
): { header: Copy; text: Copy; success: Copy } =>
  bobcat
    ? {
        header: {
          key: `${TOAST}.publishing_in_progress_header_bobcat`,
          defaultValue: 'Publishing',
        },
        text: {
          key: `${TOAST}.publishing_in_progress_text_bobcat`,
          defaultValue:
            'Editing is paused until it finishes, usually in a minute or two.',
        },
        success: {
          key: `${TOAST}.published_success_bobcat`,
          defaultValue: 'Published. You can edit again.',
        },
      }
    : {
        header: {
          key: `${TOAST}.publishing_in_progress_header`,
          defaultValue:
            "Publishing is in progress, you've been switched to view mode.",
        },
        text: {
          key: `${TOAST}.publishing_in_progress_text`,
          defaultValue:
            "We'll let you know when the solution is published and you can make edits again.",
        },
        success: {
          key: `${TOAST}.published_success`,
          defaultValue:
            "The solution has been published, you've been switched to edit mode.",
        },
      };
